import StoreButtons from "../AppLinks";
import TextTag from "../Tag";
import "./index.css";

const Download = () => {
  return (
    <section className="download">
      <div className="download__inner">
        <TextTag text="Download App" />
        <h2 className="download__title">
          Start tracking <span>today</span>
        </h2>
        <p className="download__sub">
          Free to download. No sign up required. Available on iOS and Android.
        </p>

        <div className="download__btns">
          <StoreButtons />
        </div>

        <p className="download__note">
          No ads. No account needed. Data stays in your device.
        </p>
      </div>
    </section>
  );
};

export default Download;
